import Vue from 'vue';
import Notification from '@/components/Notification/main.js';

Vue.prototype.$notify = Notification;
